import validate from 'validate.js'
import _ from 'underscore'

export const updateObject = (oldObject, updatedProperties) => {
    return {
        ...oldObject,
        ...updatedProperties
    };
};
/* Function to validate value according to rules passed
returns null or validation error message
 */
export const checkValidity = (value, rules) => {
    if (!rules) {
        return null;
    }
    return validate.single(value, rules) ?? null;
}

const validateImage = (formState, value, controlName, e) => {
    const control = formState.controls[controlName];
    const validation = control.validation ? control.validation.image : null;
    const uploadedProps = e ? e : control.uploadedProps;
    if (!uploadedProps || !validation) {
        return null;
    }
    if (e) {
        control.uploadedProps = e;
    }
    let errorMessage = null;
    const size = uploadedProps.loaded / 1024 / 1024;
    if (validation.maxSize > 0 && validation.maxSize < size) {
        errorMessage = 'The image size shouldn\'t be greater than ' + validation.maxSize + ' MB';
    }

    return errorMessage;
}

const validateField = (formState, value, controlName, event = null) => {
    if (controlName === 'phone') {
        value = value.replace(/[\._]/g, '')
    }
    let errorMessage
    console.log('formState.controls[controlName]', formState.controls[controlName]);
    if (formState.controls[controlName].controlType === 'image' && 
        formState.controls[controlName].validation && formState.controls[controlName].validation.image) {
        return validateImage(formState, value, controlName, event);
    }
    if (!_.isEmpty(formState.controls[controlName].validation)) {
        value = trim(controlName, value)
        if (isPasswordTypeField(controlName) && value !== value.trim()) {
            return ['spaces at the beginning and the end are not allowed.']
        }
        if (formState.controls[controlName].validation.email && value === '' && formState.controls[controlName].validation.email.allowEmpty === true) {
            return
        }
        if (formState.controls[controlName].validation.length && value === '' && formState.controls[controlName].validation.length.allowEmpty === true) {
            return
        }
        if (formState.controls[controlName].validation.numericality && value === '' && formState.controls[controlName].validation.numericality.allowEmpty === true) {
            return
        }
        if (formState.controls[controlName].validation.equality) {
            const compareToField = formState.controls[controlName].validation.equality
            const compareToFieldAttr = typeof compareToField === 'string' ? compareToField : compareToField.attribute;
            const constarints = {
                [controlName]: {
                    equality: compareToField
                }
            }
            errorMessage = validate({
                [controlName]: value,
                [compareToFieldAttr]: formState.controls[compareToFieldAttr].value
            }, constarints)
            
            if (errorMessage && errorMessage[controlName]) {
                errorMessage = typeof compareToField === 'object' && compareToField.message ? 
                    [compareToField.message] : errorMessage[controlName]
            }
        } else {

            errorMessage = checkValidity(value, formState.controls[controlName].validation)
        }

    }

    return errorMessage
}

validate.validators.passwordStrength = (value, options, key, attributes) => {
    
    const controlName = '__password_field';
    const pattern = options.pattern ? options.pattern : new RegExp('([a-z]+\d+)|(\d+[a-z]+)', 'i');
    let errorMessage = validate({
        [controlName]: value
    }, {
        [controlName]: {
            format: {
                pattern: pattern,
                message: options.message ? options.message : (value, attribute, validatorOptions, attributes, globalOptions) => {
                    return validate.format("Invalid strength. You can use lower case (a-z), upper case (A-Z) and numbers (0-9)");
                }
            }
        }
    });

    if (errorMessage && errorMessage[controlName]) {
        errorMessage = String(errorMessage[controlName]).replace(controlName, '');
    }

    return errorMessage;
};

export const inputChangedHandler = (formState, setFormState, value, controlName, needValidation = false, event = null) => {

    const updatedState = JSON.parse(JSON.stringify(formState));
    const field = updatedState.controls[controlName]
    if (field.hasOwnProperty('inputFilter')) {
        const regExp = new RegExp(field.inputFilter, 'g')
        value = value.replace(regExp, '');
    }

    field.value = value;
    field.touched = true;

    if (needValidation) {
        let errorMessage = validateField(formState, value, controlName, event);
        field.valid = !errorMessage;
        if (errorMessage && field.hasOwnProperty('label')) {
            errorMessage = field.label + " " + errorMessage
        }
        field.helperText = errorMessage;
    }

    const isFormValid = Object.entries(updatedState.controls).every(element => element[1].valid);
    updatedState.valid = isFormValid;
    updatedState.touched = true;
    const newFormState = {...formState, ...updatedState};
    setFormState(newFormState);

    return newFormState;
}

export const validateForm = (formState, setFormState, fieldsToValidate = []) => {
    const updatedState = JSON.parse(JSON.stringify(formState));
    if (fieldsToValidate.length === 0) {
        for (let key in updatedState.controls) {
            fieldsToValidate.push(key)
        }
    }

    let isFormValid = true
    fieldsToValidate.forEach((key) => {

        const field = updatedState.controls[key]
        field.value = trim(key, field.value)
        let errorMessage
        let result = validateField(formState, field.value, key, true);
        if (result) {
            errorMessage = result[0]
            if (field.hasOwnProperty('label') && field.label &&
                String(errorMessage).toLowerCase().indexOf(String(field.label).toLowerCase()) !== 0) {
                errorMessage = `${field.label} ${errorMessage}`
            }
        }
        field.valid = !errorMessage;
        field.touched = true;
        field.helperText = errorMessage;
        if (!field.valid) {
            console.log(field)
            isFormValid = false
        }
    })

    updatedState.valid = isFormValid;
    updatedState.touched = true
    setFormState({...formState, ...updatedState});
    return isFormValid
}

export const prepareFormData = (formData, state = null) => {
    const formDataUpdated = JSON.parse(JSON.stringify(formData));
    for (let key in formDataUpdated.controls) {
        const field = formDataUpdated.controls[key]
        field.key = key;
        if (state && state.hasOwnProperty(key)) {
            field.value = (state[key]) ?? ''
            field.valid = true
        } else {
            field.valid = true
        }
    }
    return formDataUpdated;
}

export const getFormData = (formData) => {
    const data = {};
    for (let key in formData.controls) {
        let value = formData.controls[key].value;
        value = trim(key, value)
        data[key] = value
    }
    return data;
}

const trim = (key, value) => {
    if (typeof value === 'string' && !isPasswordTypeField(key)) {
        return value.trim()
    }
    return value
}

const isPasswordTypeField = (key) => {
    return ['password', 'repassword', 'newPassword', 'oldPassword', 'confirmPassword'].includes(key)
}

export const cloneObject = (obj) => {
    return JSON.parse(JSON.stringify(obj));
}

export const validateResponse = (response) => {
    return (response.status === 200 && !response.data.error) ? true : false
}

export const getResponseError = (response) => {
    if (response.status === 200 && !response.data && !response.data.error) {
        return null;
    }

    return response.data.error ? response.data.error : 'Request failed';
}

export const isRetinaScreen = () => {
    return ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx), only screen and (min-resolution: 75.6dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min--moz-device-pixel-ratio: 2), only screen and (min-device-pixel-ratio: 2)').matches)) || (window.devicePixelRatio && window.devicePixelRatio >= 2)) && /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
}

export const copyObject = (obj) => {
    return Array.isArray(obj) ? [].concat(obj.map(item => copyObject(item))) : Object.assign({}, obj);
}